"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _InitializeAuthentication = _interopRequireDefault(require("./InitializeAuthentication"));
var _InitializeAuthenticationHelp = _interopRequireDefault(require("./InitializeAuthenticationHelp"));
var _InitializeAuthenticationLaunch = _interopRequireDefault(require("./InitializeAuthenticationLaunch"));
var _InitializeAuthenticationReset = _interopRequireDefault(require("./InitializeAuthenticationReset"));
var _UsernamePasswordStep = _interopRequireDefault(require("./UsernamePasswordStep"));
var _OtpDeliveryMethodStep = _interopRequireDefault(require("./OtpDeliveryMethodStep"));
var _OtpVerificationStep = _interopRequireDefault(require("./OtpVerificationStep"));
var _TermsAndConditionsStep = _interopRequireDefault(require("./TermsAndConditionsStep"));
var _AuthenticationHelpStep = _interopRequireDefault(require("./AuthenticationHelpStep"));
var _ResetUserIdStep = _interopRequireDefault(require("./ResetUserIdStep"));
var _ResetPasswordStep = _interopRequireDefault(require("./ResetPasswordStep"));
var _RetrieveUserIdStep = _interopRequireDefault(require("./RetrieveUserIdStep"));
var _RunasUserSelectionStep = _interopRequireDefault(require("./RunasUserSelectionStep"));
var _TokenAuthenticationStep = _interopRequireDefault(require("./TokenAuthenticationStep"));
var _WelcomeTokenStep = _interopRequireDefault(require("./WelcomeTokenStep"));
var _WelcomeResetAccountStep = _interopRequireDefault(require("./WelcomeResetAccountStep"));
var _WelcomeResetPasswordStep = _interopRequireDefault(require("./WelcomeResetPasswordStep"));
var _RunasDatasourceSelectionStep = _interopRequireDefault(require("./RunasDatasourceSelectionStep"));
var _AzureAuthenticationStep = _interopRequireDefault(require("./AzureAuthenticationStep"));
var _ParticipantIndentificationHelpStep = _interopRequireDefault(require("./ParticipantIndentificationHelpStep"));
var _OauthCodeRequestStepModule = _interopRequireDefault(require("./OauthCodeRequestStepModule"));
var _KbaResponseStep = _interopRequireDefault(require("./KbaResponseStep"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const AuthComponentLoader = function (authComponent, listener) {
  let stepResponse = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  let props = arguments.length > 3 ? arguments[3] : undefined;
  const customAuthComponentLoader = props.authComponentLoader;
  if (customAuthComponentLoader) {
    const CustomAuthComponent = customAuthComponentLoader(authComponent, listener, stepResponse, props);
    if (CustomAuthComponent) {
      return /*#__PURE__*/_react.default.createElement(CustomAuthComponent, _extends({
        listener: listener,
        stepResponse: stepResponse
      }, props));
    }
  }

  // eslint-disable-next-line no-console
  if (authComponent === 'AzureAuthenticationStep') {
    return /*#__PURE__*/_react.default.createElement(_AzureAuthenticationStep.default, _extends({
      listener: listener,
      stepResponse: stepResponse
    }, props));
  }
  if (authComponent === 'OauthCodeRequestStep') {
    return /*#__PURE__*/_react.default.createElement(_OauthCodeRequestStepModule.default, _extends({
      listener: listener,
      stepResponse: stepResponse
    }, props));
  }
  if (authComponent === 'InitializeAuthentication') {
    return /*#__PURE__*/_react.default.createElement(_InitializeAuthentication.default, _extends({
      listener: listener,
      stepResponse: stepResponse
    }, props));
  }
  if (authComponent === 'InitializeAuthenticationLaunch') {
    return /*#__PURE__*/_react.default.createElement(_InitializeAuthenticationLaunch.default, _extends({
      listener: listener,
      stepResponse: stepResponse
    }, props));
  }
  if (authComponent === 'UsernamePasswordStep') {
    return /*#__PURE__*/_react.default.createElement(_UsernamePasswordStep.default, _extends({
      listener: listener,
      stepResponse: stepResponse
    }, props));
  }
  if (authComponent === 'OtpDeliveryMethodStep') {
    return /*#__PURE__*/_react.default.createElement(_OtpDeliveryMethodStep.default, _extends({
      listener: listener,
      stepResponse: stepResponse
    }, props));
  }
  if (authComponent === 'OtpVerificationStep') {
    return /*#__PURE__*/_react.default.createElement(_OtpVerificationStep.default, _extends({
      listener: listener,
      stepResponse: stepResponse
    }, props));
  }
  if (authComponent === 'KbaResponseStep') {
    return /*#__PURE__*/_react.default.createElement(_KbaResponseStep.default, _extends({
      listener: listener,
      stepResponse: stepResponse
    }, props));
  }
  if (authComponent === 'TermsAndConditionsStep') {
    return /*#__PURE__*/_react.default.createElement(_TermsAndConditionsStep.default, _extends({
      listener: listener,
      stepResponse: stepResponse
    }, props));
  }
  if (authComponent === 'InitializeAuthenticationHelp') {
    return /*#__PURE__*/_react.default.createElement(_InitializeAuthenticationHelp.default, _extends({
      listener: listener,
      stepResponse: stepResponse
    }, props));
  }
  if (authComponent === 'AuthenticationHelpStep') {
    return /*#__PURE__*/_react.default.createElement(_AuthenticationHelpStep.default, _extends({
      listener: listener,
      stepResponse: stepResponse
    }, props));
  }
  if (authComponent === 'ParticipantIndentificationHelpStep') {
    return /*#__PURE__*/_react.default.createElement(_ParticipantIndentificationHelpStep.default, _extends({
      listener: listener,
      stepResponse: stepResponse
    }, props));
  }
  if (authComponent === 'ResetUserIdStep') {
    return /*#__PURE__*/_react.default.createElement(_ResetUserIdStep.default, _extends({
      listener: listener,
      stepResponse: stepResponse
    }, props));
  }
  if (authComponent === 'ResetPasswordStep') {
    return /*#__PURE__*/_react.default.createElement(_ResetPasswordStep.default, _extends({
      listener: listener,
      stepResponse: stepResponse
    }, props));
  }
  if (authComponent === 'RetrieveUserIdStep') {
    return /*#__PURE__*/_react.default.createElement(_RetrieveUserIdStep.default, _extends({
      listener: listener,
      stepResponse: stepResponse
    }, props));
  }
  if (authComponent === 'RunasUserSelectionStep') {
    return /*#__PURE__*/_react.default.createElement(_RunasUserSelectionStep.default, _extends({
      listener: listener,
      stepResponse: stepResponse
    }, props));
  }
  if (authComponent === 'InitializeAuthenticationReset') {
    return /*#__PURE__*/_react.default.createElement(_InitializeAuthenticationReset.default, _extends({
      listener: listener,
      stepResponse: stepResponse
    }, props));
  }
  if (authComponent === 'TokenAuthenticationStep') {
    return /*#__PURE__*/_react.default.createElement(_TokenAuthenticationStep.default, _extends({
      listener: listener,
      stepResponse: stepResponse
    }, props));
  }
  if (authComponent === 'WelcomeTokenStep') {
    return /*#__PURE__*/_react.default.createElement(_WelcomeTokenStep.default, _extends({
      listener: listener,
      stepResponse: stepResponse
    }, props));
  }
  if (authComponent === 'WelcomeResetAccountStep') {
    return /*#__PURE__*/_react.default.createElement(_WelcomeResetAccountStep.default, _extends({
      listener: listener,
      stepResponse: stepResponse
    }, props));
  }
  if (authComponent === 'WelcomeResetPasswordStep') {
    return /*#__PURE__*/_react.default.createElement(_WelcomeResetPasswordStep.default, _extends({
      listener: listener,
      stepResponse: stepResponse
    }, props));
  }
  if (authComponent === 'RunasDatasourceSelectionStep') {
    return /*#__PURE__*/_react.default.createElement(_RunasDatasourceSelectionStep.default, _extends({
      listener: listener,
      stepResponse: stepResponse
    }, props));
  }
  return /*#__PURE__*/_react.default.createElement(_react.Fragment, null);
};
AuthComponentLoader.propTypes = {
  authComponentLoader: _propTypes.default.func
};
var _default = exports.default = AuthComponentLoader;
//# sourceMappingURL=AuthComponentLoader.js.map